import { useForm, zodResolver } from '@mantine/form';

import { useUpdateDeclarationDataLrn, useUpdatePartialDeclaration } from '@hooks/declaration';
import { isHighValueDeclaration } from '@utils';
import { DeclarationViewDV1FormValues, declarationViewDV1Schema } from './validateDeclarationViewDV1Form';

export const useDeclarationViewDV1Form = ({ declaration }) => {
  const saveDeclarationDataLRNMutation = useUpdateDeclarationDataLrn();
  const savePartialDataToDeclarationMutation = useUpdatePartialDeclaration();

  const buildFormValues = (d) => ({
    dv1: {
      seller: {
        header: d?.dv1?.seller?.header,
        name: d?.dv1?.seller?.name,
        identificationNumber: d?.dv1?.seller?.identificationNumber,
        address: {
          street: d?.dv1?.seller?.address?.street,
          city: d?.dv1?.seller?.address?.city,
          postcode: d?.dv1?.seller?.address?.postcode,
          country: d?.dv1?.seller?.address?.country,
        },
      },
      buyer: {
        header: d?.dv1?.buyer?.header,
        identificationNumber: d?.dv1?.buyer?.identificationNumber,
        name: d?.dv1?.buyer?.name,
        address: {
          street: d?.dv1?.buyer?.address?.street,
          city: d?.dv1?.buyer?.address?.city,
          postcode: d?.dv1?.buyer?.address?.postcode,
          country: d?.dv1?.buyer?.address?.country,
        },
      },
      contract: {
        contractNumber: d?.dv1?.contract?.contractNumber,
        contractDate: d?.dv1?.contract?.contractDate,
      },
      BuyerSellerRelation: {
        relation: d?.dv1?.BuyerSellerRelation?.relation,
      },
      RestrictionsAndConditions: {
        restrictions: d?.dv1?.RestrictionsAndConditions?.restrictions,
        consideration: d?.dv1?.RestrictionsAndConditions?.consideration,
        resale: d?.dv1?.RestrictionsAndConditions?.resale,
      },
      RoyaltiesAndResale: {
        royalties: d?.dv1?.RoyaltiesAndResale?.royalties,
      },
      signature: {
        place: d?.dv1?.signature?.place,
      },
    },
  });

  const form = useForm<DeclarationViewDV1FormValues>({
    initialValues: buildFormValues(declaration),
    validate: zodResolver(declarationViewDV1Schema),
    validateInputOnBlur: true,
  });

  const onSubmit = async (values) => {
    if (isHighValueDeclaration(declaration.generalInfo.group)) {
      await saveDeclarationDataLRNMutation.mutateAsync({
        lrn: declaration.messageInfo.LRN,
        sequence: declaration.goodShipmentGlobal.sequence,
        partialDeclaration: values,
      });
    } else {
      await savePartialDataToDeclarationMutation.mutateAsync({
        id: declaration._id,
        partialDeclaration: values,
      });
    }
  };

  return {
    form,
    isSaving: saveDeclarationDataLRNMutation.isPending || savePartialDataToDeclarationMutation.isPending,
    onSubmit,
    buildFormValues,
  };
};
